import React from "react";

const Home = () => {
  return (
    <div>
      <h1>Administration Home</h1>
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.jsx